module.exports = __webpack_public_path__ + "static/media/horizontalRectangle_black.f40131ab.svg";